import React from "react";
import { Helmet } from "react-helmet-async";
import "./ContentCreation.css";


// Import images
import ContentHeroImg from "../assets/content-hero.jpeg";



const ContentCreation = () => {
  const handleCTAClick = () => {
    if (window.gtag) {
      window.gtag("event", "click", {
        event_category: "CTA",
        event_label: "WhatsApp CTA",
        value: 1,
      });
    }
  };

  

  return (
    <>
      {/* SEO */}
      <Helmet>
        <title>Content Creation Services in Kenya | SEO Content & Video Marketing</title>

<link rel="canonical" href="https://satimatechnova.co.ke/content-creation-services/" />

        <meta
          name="description"
          content="Professional content creation services in Kenya including SEO blogs, social media content, video marketing, and content strategy to help businesses attract and convert customers."
        />

        <meta
          name="keywords"
          content="content creation services Kenya, SEO content Kenya, blog writing Kenya, social media content Kenya, video marketing Kenya, content strategy Kenya, Satima Technova Solutions"
        />

        <meta name="author" content="Satima Technova" />

        {/* Open Graph */}
        <meta property="og:title" content="Content Creation Services in Kenya" />
        <meta property="og:description" content="Grow your business with strategic content creation, SEO blogs, and video marketing in Kenya." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://satimatechnova.co.ke/content-creation-services/" />


        <script type="application/ld+json">
{JSON.stringify({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [

    {
      "@type": "Question",
      "name": "How much do content creation services cost?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Content creation is included as part of our social media marketing and digital marketing packages. The investment depends on your business goals, content requirements, and the level of marketing support needed. Basic Digital Marketing Package starts from KSh 6,000 per month, while the Premium Digital Marketing Package starts from KSh 12,000 per month. Packages may include content planning, social media graphics, captions, posting support, audience engagement, and performance tracking depending on the selected plan."
      }
    },


    {
      "@type": "Question",
      "name": "What types of content do you create?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We create different types of business content including social media posts, graphics, videos, blog articles, website content, email marketing content, and strategic content plans."
      }
    },


    {
      "@type": "Question",
      "name": "Why does my business need professional content creation?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Professional content helps your business build trust, attract the right audience, improve brand visibility, and communicate your value effectively online."
      }
    },


    {
      "@type": "Question",
      "name": "How often should my business post content online?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The ideal posting frequency depends on your industry, audience, and marketing goals. We create structured content plans to ensure consistent and strategic posting."
      }
    },


    {
      "@type": "Question",
      "name": "Do you create content for social media platforms?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. We create platform-specific content for Facebook, Instagram, LinkedIn, and other social platforms designed to improve engagement and strengthen your online presence."
      }
    },


    {
      "@type": "Question",
      "name": "Can you help improve my existing content strategy?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. We analyze your current content, identify improvement areas, and recommend strategies that can help you achieve better visibility and engagement."
      }
    },


    {
      "@type": "Question",
      "name": "How do I get started?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Simply contact Satima Technova Solutions for a consultation. We will understand your business goals, recommend the right content approach, and help you build a strategy that supports growth."
      }
    }

  ]
})}
</script>


      </Helmet>

      <main className="content-page">

    <section className="cc-trust-scroll">

  <div className="cc-trust-track">

    <div className="cc-trust-content">

      <span>✓ Strategic Content Creation</span>

      <span>✓ Brand Storytelling</span>

      <span>✓ SEO Optimized Content</span>

      <span>✓ Audience Engagement</span>

    </div>


    <div className="cc-trust-content">

      <span>✓ Strategic Content Creation</span>

      <span>✓ Brand Storytelling</span>

      <span>✓ SEO Optimized Content</span>

      <span>✓ Audience Engagement</span>

    </div>

  </div>

</section>



        {/* HERO */}

<section
  className="cc-hero-section"
  style={{
    backgroundImage: `url(${ContentHeroImg})`
  }}
>

  <div className="cc-hero-overlay">

    <div className="cc-hero-wrapper">

      <div className="cc-hero-text">

        {/* Hidden visually but kept for SEO */}

        <h1 className="cc-hidden-heading">
          Content Creation Services in Kenya That Drive Real Business Growth
        </h1>

        <div className="cc-intro-content">

          <span className="cc-hero-tag">
            CONTENT CREATION SERVICES
          </span>

          <h2>
            Content That Builds Trust
            <br />
            <span>And Grows Your Brand.</span>
          </h2>

          <p className="cc-intro-line">
            Strategic content designed to attract the right audience,
            build credibility, and turn attention into business growth.
          </p>

        </div>

        <a
          href="https://wa.me/254775137928?text=Hi%20Satima%20Technova,%20I%E2%80%99m%20interested%20in%20your%20content%20creation%20services."
          target="_blank"
          rel="noopener noreferrer"
          className="cc-hero-cta"
        >
          Start Your Content Strategy
        </a>

        <div className="cc-trust-points">

          <p>
            ✓ Audience-focused content
          </p>

          <p>
            ✓ SEO-friendly strategies
          </p>

          <p>
            ✓ Content built for growth
          </p>

        </div>

      </div>

    </div>

  </div>

</section>


{/* =========================================================
    THE CONTENT PROBLEM
========================================================= */}

<section className="content-problem-section">

  <div className="content-problem-container">

    {/* SECTION HEADER */}

    <div className="content-problem-header">

      <span className="content-problem-label">
        THE CONTENT PROBLEM
      </span>

      <h2>
        Content Should Do More
        <br />
        Than Fill Your Feed.
      </h2>

      <p>
        Publishing content consistently is not the same as having
        a content strategy. The difference is knowing why each piece
        exists and what it is meant to achieve.
      </p>

    </div>


    {/* MAIN CONTENT */}

    <div className="content-problem-card">

      <div className="content-problem-accent"></div>

      <div className="content-problem-content">


        {/* LEFT SIDE */}

        <div className="content-problem-statement">

          <span className="content-problem-quote">
            “
          </span>

          <h3>
            Posting
            <br />
            <span>Is Not Strategy.</span>
          </h3>

        </div>


        {/* RIGHT SIDE */}

        <div className="content-problem-message">

          <p>
            Many businesses create content simply because they feel
            they should be posting. But without a clear direction,
            even good content can become
            <strong> noise instead of value.</strong>
          </p>


          <div className="content-problem-principles">


            {/* 01 */}

            <div className="content-problem-principle">

              <span className="content-problem-number">
                01
              </span>

              <div>

                <h4>
                  Content Has a Purpose
                </h4>

                <p>
                  Every piece should have a reason, whether it is
                  building awareness, educating your audience,
                  creating trust, or encouraging action.
                </p>

              </div>

            </div>


            {/* 02 */}

            <div className="content-problem-principle">

              <span className="content-problem-number">
                02
              </span>

              <div>

                <h4>
                  Content Works Together
                </h4>

                <p>
                  Your posts, articles, visuals, and videos should
                  support one another instead of becoming isolated
                  pieces of content.
                </p>

              </div>

            </div>


            {/* 03 */}

            <div className="content-problem-principle">

              <span className="content-problem-number">
                03
              </span>

              <div>

                <h4>
                  Content Serves the Business
                </h4>

                <p>
                  The goal is not simply to publish more. It is to
                  create content that supports visibility, trust,
                  enquiries, and long term growth.
                </p>

              </div>

            </div>


          </div>


          {/* HIGHLIGHT */}

          <div className="content-problem-highlight">

            <span className="content-problem-highlight-line"></span>

            <p>
              Your business doesn't need
              <strong> more content.</strong>
              It needs content with a reason.
            </p>

          </div>

        </div>

      </div>

    </div>

  </div>

</section>


{/* =========================================================
    WHAT WE CREATE
========================================================= */}

<section className="content-create-section">

  <div className="content-create-container">

    {/* SECTION HEADER */}

    <div className="content-create-header">

      <span className="content-create-label">
        WHAT WE CREATE
      </span>

      <h2>
        Content Built Around
        <br />
        a Clear Direction.
      </h2>

      <p>
        We create content across the key areas your business
        needs to attract attention, build trust, and move people to action.
      </p>

    </div>


    {/* STRATEGIC AREAS */}

    <div className="content-create-list">


      {/* 01 — STRATEGY */}

      <div className="content-create-item">

        <div className="content-create-number">
          01
        </div>

        <div className="content-create-main">

          <div className="content-create-title">
            <h3>
              Strategy
            </h3>

            <span>
              Direction
            </span>
          </div>

          <p>
            Content planning, audience understanding, messaging,
            content pillars, and calendars that give your content purpose.
          </p>

        </div>

      </div>


      {/* 02 — WRITTEN CONTENT */}

      <div className="content-create-item">

        <div className="content-create-number">
          02
        </div>

        <div className="content-create-main">

          <div className="content-create-title">
            <h3>
              Written Content
            </h3>

            <span>
              Words
            </span>
          </div>

          <p>
            Website copy, blog articles, SEO content, social captions,
            and other written content shaped around your audience.
          </p>

        </div>

      </div>


      {/* 03 — VISUAL CONTENT */}

      <div className="content-create-item">

        <div className="content-create-number">
          03
        </div>

        <div className="content-create-main">

          <div className="content-create-title">
            <h3>
              Visual Content
            </h3>

            <span>
              Attention
            </span>
          </div>

          <p>
            Social graphics, promotional visuals, short-form videos,
            and creative assets designed to communicate clearly.
          </p>

        </div>

      </div>


      {/* 04 — PERFORMANCE */}

      <div className="content-create-item">

        <div className="content-create-number">
          04
        </div>

        <div className="content-create-main">

          <div className="content-create-title">
            <h3>
              Performance
            </h3>

            <span>
              Improvement
            </span>
          </div>

          <p>
            Content performance tracking, audience response,
            engagement, and insights that help improve what comes next.
          </p>

        </div>

      </div>


    </div>


    {/* CLOSING STATEMENT */}

    <div className="content-create-footer">

      <span className="content-create-footer-line"></span>

      <p>
        From
        <strong> strategy to execution,</strong>
        every piece of content has a role to play.
      </p>

    </div>

  </div>

</section>



<section className="content-approach-section">

  <div className="content-approach-container">

    {/* SECTION HEADER */}

    <div className="content-approach-header">

      <span className="content-approach-label">
        THE SATIMA APPROACH
      </span>

      <h2>
        Content With
        <br />
         Direction.
      </h2>

      <p>
        We follow a clear process that connects strategy,
        creativity, and performance from the beginning.
      </p>

    </div>


    {/* APPROACH CARD */}

    <div className="content-approach-card">

      <div className="content-approach-accent"></div>

      <div className="content-approach-intro">

        <span className="content-approach-small-label">
          FROM IDEA TO IMPACT
        </span>

        <h3>
          A Better Way to Build Content.
        </h3>

        <p>
          Every stage has a purpose. We understand first,
          create with intention, then use performance to
          guide what comes next.
        </p>

      </div>


      {/* PROCESS */}

      <div className="content-approach-process">


        {/* 01 */}

        <div className="content-approach-step">

          <div className="content-approach-step-top">

            <span className="content-approach-number">
              01
            </span>

            <span className="content-approach-connector"></span>

          </div>

          <div className="content-approach-step-content">

            <h4>
              Understand
            </h4>

            <p>
              Your business, audience, goals, and opportunities.
            </p>

          </div>

        </div>


        {/* 02 */}

        <div className="content-approach-step">

          <div className="content-approach-step-top">

            <span className="content-approach-number">
              02
            </span>

            <span className="content-approach-connector"></span>

          </div>

          <div className="content-approach-step-content">

            <h4>
              Plan
            </h4>

            <p>
              The message, topics, formats, and direction your content needs.
            </p>

          </div>

        </div>


        {/* 03 */}

        <div className="content-approach-step">

          <div className="content-approach-step-top">

            <span className="content-approach-number">
              03
            </span>

            <span className="content-approach-connector"></span>

          </div>

          <div className="content-approach-step-content">

            <h4>
              Create
            </h4>

            <p>
              Purposeful content designed to communicate and engage.
            </p>

          </div>

        </div>


        {/* 04 */}

        <div className="content-approach-step">

          <div className="content-approach-step-top">

            <span className="content-approach-number">
              04
            </span>

          </div>

          <div className="content-approach-step-content">

            <h4>
              Measure
            </h4>

            <p>
              Results, audience response, and insights that shape what comes next.
            </p>

          </div>

        </div>


      </div>


      {/* CLOSING STATEMENT */}

      <div className="content-approach-highlight">

        <span className="content-approach-highlight-line"></span>

        <p>
          We don't just create content.
          <strong> We build a system for meaningful communication.</strong>
        </p>

      </div>

    </div>

  </div>

</section>


{/* =========================================================
    WHY CHOOSE SATIMA
========================================================= */}

<section className="content-why-section">

  <div className="content-why-container">

    {/* SECTION HEADER */}

    <div className="content-why-header">

      <span className="content-why-label">
        WHY CHOOSE SATIMA
      </span>

      <h2>
        Content Built Around
        <br />
        Your Business.
      </h2>

      <p>
        We combine strategic thinking, creative execution, and
        business understanding to create content that has a clear purpose.
      </p>

    </div>


    {/* EDITORIAL CARD */}

    <div className="content-why-card">

      <div className="content-why-accent"></div>

      <div className="content-why-content">


        {/* STATEMENT */}

        <div className="content-why-statement">

          <span className="content-why-quote">
            “
          </span>

          <h3>
            More Than
            <br />
            <span>Content Creation.</span>
          </h3>

        </div>


        {/* MESSAGE */}

        <div className="content-why-message">

          <p>
            Good content starts with
            <strong> understanding what your business needs to communicate.</strong>
            We look beyond individual posts and pieces to build content
            that supports your wider digital direction.
          </p>


          {/* PRINCIPLES */}

          <div className="content-why-principles">


            {/* 01 */}

            <div className="content-why-principle">

              <span className="content-why-number">
                01
              </span>

              <div>

                <h4>
                  Business Understanding
                </h4>

                <p>
                  We learn your business, audience, objectives,
                  and the message you need to communicate.
                </p>

              </div>

            </div>


            {/* 02 */}

            <div className="content-why-principle">

              <span className="content-why-number">
                02
              </span>

              <div>

                <h4>
                  Strategic Creativity
                </h4>

                <p>
                  We combine creative ideas with clear direction
                  so your content has meaning beyond appearance.
                </p>

              </div>

            </div>


            {/* 03 */}

            <div className="content-why-principle">

              <span className="content-why-number">
                03
              </span>

              <div>

                <h4>
                  Consistent Improvement
                </h4>

                <p>
                  We pay attention to performance and audience response
                  so your content can become more effective over time.
                </p>

              </div>

            </div>


          </div>


          {/* CLOSING STATEMENT */}

          <div className="content-why-highlight">

            <span className="content-why-highlight-line"></span>

            <p>
              We don't create content
              <strong> just to keep you visible.</strong>
              We create it to give your business something meaningful to say.
            </p>

          </div>

        </div>

      </div>

    </div>

  </div>

</section>



{/* =========================================================
    06 — CONTENT TYPES
========================================================= */}

<section className="content-types-section">

  <div className="content-types-container">

    {/* HEADER */}
    <div className="content-types-header">

      <span className="content-types-label">
        CONTENT TYPES
      </span>

      <h2>
        Content for Every
        <br />
        Stage of the Journey.
      </h2>

      <p>
        Different messages need different formats. We create
        content that helps your business attract attention,
        communicate value, and encourage action.
      </p>

    </div>


    {/* CONTENT TYPES */}
    <div className="content-types-layout">

      {/* FEATURED */}
      <div className="content-types-featured">

        <span className="content-types-featured-number">
          01
        </span>

        <div className="content-types-featured-content">

          <span className="content-types-mini-label">
            LONG FORM
          </span>

          <h3>
            Blog Content
          </h3>

          <p>
            Useful, well structured articles that educate your
            audience, build authority, and support your wider
            digital strategy.
          </p>

        </div>

        <span className="content-types-arrow">
          ↗
        </span>

      </div>


      {/* LIST */}
      <div className="content-types-list">

        <div className="content-types-item">

          <span className="content-types-number">
            02
          </span>

          <div className="content-types-item-main">

            <h3>
              Social Media
            </h3>

            <p>
              Purposeful posts and captions designed to keep
              your audience informed, engaged, and connected.
            </p>

          </div>

          <span className="content-types-item-arrow">
            ↗
          </span>

        </div>


        <div className="content-types-item">

          <span className="content-types-number">
            03
          </span>

          <div className="content-types-item-main">

            <h3>
              Graphics
            </h3>

            <p>
              Clear visual content that communicates your
              message quickly and strengthens your brand.
            </p>

          </div>

          <span className="content-types-item-arrow">
            ↗
          </span>

        </div>


        <div className="content-types-item">

          <span className="content-types-number">
            04
          </span>

          <div className="content-types-item-main">

            <h3>
              Video
            </h3>

            <p>
              Short form and promotional video content created
              to capture attention and tell your story.
            </p>

          </div>

          <span className="content-types-item-arrow">
            ↗
          </span>

        </div>


        <div className="content-types-item">

          <span className="content-types-number">
            05
          </span>

          <div className="content-types-item-main">

            <h3>
              Email
            </h3>

            <p>
              Strategic email content that keeps your audience
              informed and encourages meaningful action.
            </p>

          </div>

          <span className="content-types-item-arrow">
            ↗
          </span>

        </div>


        <div className="content-types-item">

          <span className="content-types-number">
            06
          </span>

          <div className="content-types-item-main">

            <h3>
              SEO Content
            </h3>

            <p>
              Search focused content designed to improve
              visibility while remaining useful to real people.
            </p>

          </div>

          <span className="content-types-item-arrow">
            ↗
          </span>

        </div>

      </div>

    </div>


    {/* CLOSING */}
    <div className="content-types-footer">

      <span className="content-types-footer-line"></span>

      <p>
        One strategy.
        <strong> Multiple formats.</strong>
        One consistent direction.
      </p>

    </div>

  </div>

</section>


{/* =====================================
    FAQ SECTION
===================================== */}

<section className="faq-section">


  <div className="faq-header">


    <h2>
      Frequently Asked Questions
    </h2>


    <p>
      Find answers to common questions about our content creation services
      for businesses in Kenya.
    </p>


  </div>




  <div className="faq-container">



    <details className="faq-item" open>


  <summary>
    How much do content creation services cost?
  </summary>


  <p>
    Content creation is included as part of our social media marketing and
    digital marketing packages. The investment depends on your business goals,
    content requirements, and the level of marketing support needed.
  </p>


  <ul>

    <li>
      <strong>Basic Digital Marketing Package:</strong> KSh 6,000 per month
    </li>


    <li>
      <strong>Premium Digital Marketing Package:</strong> KSh 12,000 per month
    </li>


  </ul>


  <p>
    Each package can include content planning, social media graphics,
    captions, posting support, audience engagement, and performance tracking
    depending on your selected plan.
  </p>


</details>





    <details className="faq-item">


      <summary>
        What types of content do you create?
      </summary>


      <p>
        We create different types of business content including social media
        posts, graphics, videos, blog articles, website content, email
        marketing content, and strategic content plans.
      </p>


    </details>





    <details className="faq-item">


      <summary>
        Why does my business need professional content creation?
      </summary>


      <p>
        Professional content helps your business build trust, attract the
        right audience, improve brand visibility, and communicate your value
        effectively online.
      </p>


    </details>





    <details className="faq-item">


      <summary>
        How often should my business post content online?
      </summary>


      <p>
        The ideal posting frequency depends on your industry, audience, and
        marketing goals. We create structured content plans to ensure
        consistent and strategic posting.
      </p>


    </details>





    <details className="faq-item">


      <summary>
        Do you create content for social media platforms?
      </summary>


      <p>
        Yes. We create platform-specific content for Facebook, Instagram,
        LinkedIn, and other social platforms designed to improve engagement
        and strengthen your online presence.
      </p>


    </details>





    <details className="faq-item">


      <summary>
        Can you help improve my existing content strategy?
      </summary>


      <p>
        Yes. We analyze your current content, identify improvement areas, and
        recommend strategies that can help you achieve better visibility and
        engagement.
      </p>


    </details>





    <details className="faq-item">


      <summary>
        How do I get started?
      </summary>


      <p>
        Simply contact Satima Technova Solutions for a consultation. We will
        understand your business goals, recommend the right content approach,
        and help you build a strategy that supports growth.
      </p>


    </details>



  </div>


</section>
        
        
        {/* =========================================================
    FINAL CTA — CONTENT CREATION
========================================================= */}

<section className="final-cta-section">

  <div className="final-cta-content">

    <span className="final-cta-label">
      READY TO CREATE WITH PURPOSE?
    </span>


    <h2>
      Give Your Business
      <br />
      Something Worth Saying.
    </h2>


    <p>
      Build a content system that connects your message,
      audience, and business goals. From strategy and social
      media to SEO, visuals, and video, create content with
      a clear reason behind it.
    </p>


    <div className="final-cta-divider">
      <span></span>
    </div>


    <div className="final-cta-points">

      <span>
        Strategy
      </span>

      <span>
        Creativity
      </span>

      <span>
        Consistency
      </span>

      <span>
        Growth
      </span>

    </div>


    <a
      href="https://wa.me/254775137928?text=Hi%20Satima%20Technova,%20I'm%20interested%20in%20your%20content%20creation%20services."
      target="_blank"
      rel="noopener noreferrer"
      className="final-cta-btn"
      onClick={handleCTAClick}
    >
      Start a Conversation
      <span>↗</span>
    </a>


    <p className="final-cta-note">
      Strategic content creation for businesses across Kenya
    </p>

  </div>

</section>

      </main>
    </>
  );
};

export default ContentCreation;